import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * Добавить email
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Contacts/f51565fdbca29c63108097fda47f6eaa
 * */
export const addUnconfirmedEmail = (params: RequestDto): IRequest => ({
    uri: '/v1/contacts/add-unconfirmed-email',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(params),
});
